module.exports = __webpack_public_path__ + "img/sus.382b8542.svg";